// extracted by mini-css-extract-plugin
export var label = "_e0-1";
export var reminder = "_e0-0";